import { Button } from "@gravity-ui/uikit";
import { useAtom } from "@reatom/npm-react";

import { SWIPER_SLIDE_CHANGE_SPEED } from "../constants";
import { swiperAtom } from "../store";
import css from "../WelcomeModal.module.scss";

export const SliderDotsControls = () => {
  const [swiperRef] = useAtom(swiperAtom);

  return (
    <div className={css.sliderDotsControlsContainer}>
      {swiperRef?.slides?.map((_, index) => {
        return (
          <Button
            key={"slide-button." + index}
            view={swiperRef.activeIndex === index ? "action" : "normal"}
            width="auto"
            onClick={() => {
              swiperRef?.slideTo(index, SWIPER_SLIDE_CHANGE_SPEED);
            }}
          />
        );
      })}
    </div>
  );
};
